import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=285d9076&scoped=true"
import script from "./spinner.vue?vue&type=script&lang=js"
export * from "./spinner.vue?vue&type=script&lang=js"
import style0 from "./spinner.styl?vue&type=style&index=0&id=285d9076&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285d9076",
  null
  
)

export default component.exports